export default "__VITE_ASSET__fe01dbb3__"